import { env, isDev, isProd } from "./env";

export const appConfig = {
  name: env.VITE_APP_NAME,
  version: env.VITE_APP_VERSION,

  api: {
    baseUrl: env.VITE_API_BASE_URL,
    timeout: 30_000,
    retryAttempts: 3,
    retryDelay: 1000,
  },

  auth: {
    accessTokenExpiryBuffer: 60_000, // 1 minute before expiry
    // refreshEndpoint: '/auth/refresh',
    // loginEndpoint: '/auth/login',
    // logoutEndpoint: '/auth/logout',
  },

  features: {
    devTools: env.VITE_ENABLE_DEVTOOLS && isDev,
  },

  observability: {
    sentryDsn: env.VITE_SENTRY_DSN,
    enableSentry: isProd && Boolean(env.VITE_SENTRY_DSN),
  },
} as const;

export type AppConfig = typeof appConfig;
